import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ResumeDownload from "./ResumeDownload";

const Hero = () => {
  const [typedName, setTypedName] = useState("");
  const fullName = "Nguyen Thanh Long";

  // Calculate years of experience
  const calculateExperience = () => {
    const startDate = new Date("2018-06-01");
    const currentDate = new Date();
    const diffInYears =
      (currentDate.getTime() - startDate.getTime()) /
      (1000 * 3600 * 24 * 365.25);
    return Math.floor(diffInYears) + "+";
  };

  // Typing animation effect
  useEffect(() => {
    let i = 0;
    const typingTimer = setTimeout(() => {
      const typeWriter = () => {
        if (i < fullName.length) {
          setTypedName(fullName.slice(0, i + 1));
          i++;
          setTimeout(typeWriter, 100); // 100ms delay between characters
        }
      };
      typeWriter();
    }, 1000); // Start typing after 1 second

    return () => clearTimeout(typingTimer);
  }, [fullName]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-container">
        <motion.div
          className="hero-content"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h1 className="hero-title">
            <span className="title-line">Hello, I'm</span>
            <span className="title-name">
              {typedName}
              {typedName.length < fullName.length && (
                <span className="typing-cursor">|</span>
              )}
            </span>
          </h1>
          <p className="hero-subtitle">Senior Software Engineer & Team Lead</p>
          <p className="hero-description">
            Passionate software developer with{" "}
            <span className="years-experience">{calculateExperience()}</span>{" "}
            years of experience in building scalable web applications,
            AI-powered document processing systems, and leading cross-functional
            teams to deliver high-quality solutions.
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary">
              Get In Touch
            </a>
            <a href="#about" className="btn btn-secondary">
              Learn More
            </a>
            <ResumeDownload />
          </div>
        </motion.div>

        <motion.div
          className="hero-image"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.4 }}
        >
          <div className="profile-card">
            <div className="profile-avatar">
              <img
                src="images/IMG_20200823_184001_299.jpg"
                alt="Nguyen Thanh Long - Profile Picture"
                className="profile-picture"
              />
            </div>
            <div className="profile-info">
              <h3>Nguyen Thanh Long</h3>
              <p>Senior Software Engineer</p>
              <div className="profile-location">
                <i className="fas fa-map-marker-alt"></i>
                <span>Ho Chi Minh City, Vietnam</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="hero-bg-animation"></div>
    </section>
  );
};

export default Hero;
